import script from "./AgentSetupStyleLightTab.vue?vue&type=script&setup=true&lang=js"
export * from "./AgentSetupStyleLightTab.vue?vue&type=script&setup=true&lang=js"

import "./AgentSetupStyleLightTab.vue?vue&type=style&index=0&id=077bac84&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-077bac84"]])

export default __exports__